<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>
import Home from './pages/Home.vue'

export default {
  name: 'app',
  components: {
    Home
  }
}
</script>

<style>
#app {
  font-family: 'Roboto Slab', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
h1, h2, h3, h4, h5, h6, button, select {
  font-family: inherit;
}

.blue-text {
  color: #2199e8;
}

.blue {
  background-color: #2199e8;
}

.clearfix {
  height: 2em;
}
</style>
